var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoRecordFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 101,
    viewBox: "0 0 136 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: 0.05,
    d: "M90.0859 61.413C89.1491 62.5266 88.1376 62.508 87.5347 62.351L87.5571 61.7742C87.5571 61.7742 90.0485 60.6356 89.985 60.8748C89.9613 60.9645 90.0087 61.18 90.0859 61.413Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.05,
    d: "M96.9134 62.6735C95.3227 63.5928 94.3896 62.5153 94.1729 62.2101C94.3061 61.86 94.5067 61.292 94.4656 61.13C94.4058 60.8896 96.8935 62.0282 96.8935 62.0282L96.9134 62.6735Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    opacity: 0.05,
    d: "M95.2095 53.5015C95.2095 53.5015 96.723 52.6295 97.0531 53.0219C97.3833 53.4143 95.2095 53.5015 95.2095 53.5015Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    opacity: 0.05,
    d: "M96.1237 53.981C96.1237 53.981 95.8746 54.1055 96.424 54.265C96.9733 54.4244 96.1237 53.981 96.1237 53.981Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    opacity: 0.05,
    d: "M86.9717 51.5831C86.9206 51.5981 88.2311 52.4676 89.4145 51.7476C89.4095 51.7476 87.2669 51.4934 86.9717 51.5831Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    opacity: 0.05,
    d: "M89.35 53.2461C89.35 53.2461 88.9912 53.9512 88.2562 54.0558C87.5212 54.1604 89.35 53.2461 89.35 53.2461Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    opacity: 0.05,
    d: "M94.1606 54.7759C94.1606 54.7759 95.8847 57.5165 95.5546 58.163C95.2245 58.8095 94.1606 54.7759 94.1606 54.7759Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    opacity: 0.05,
    d: "M90.7587 65.6734C90.7587 65.8266 90.7587 65.9698 90.7437 66.0882C90.6989 66.6425 89.3348 66.4332 89.3348 66.4332C88.0891 66.6064 87.6406 66.0085 87.4924 65.4367C87.4458 65.2509 87.4228 65.0601 87.4239 64.8686C87.4231 64.7545 87.4306 64.6404 87.4463 64.5273V64.4139C87.7148 64.333 88.0059 64.3924 88.2211 64.5721C88.7755 65.0218 89.5105 64.6768 89.5105 64.6768C89.5105 64.6768 90.0499 64.7216 90.2579 64.901C90.375 65.0019 90.5681 64.759 90.7151 64.5273C90.7238 64.6768 90.7375 64.9471 90.7462 65.2361C90.7562 65.3843 90.7587 65.5338 90.7587 65.6734Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    opacity: 0.05,
    d: "M88.5712 65.6409C88.5712 65.6409 88.1975 66.0071 87.4924 65.4416C87.4458 65.2559 87.4228 65.065 87.4239 64.8735C87.7839 65.1476 88.4516 65.6409 88.5712 65.6409Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    opacity: 0.05,
    d: "M90.7584 65.6734C90.6969 65.7208 90.6186 65.7407 90.542 65.7284C90.4653 65.7162 90.3971 65.6728 90.3535 65.6086C90.4988 65.498 90.6324 65.3728 90.7521 65.2349C90.7559 65.3843 90.7584 65.5338 90.7584 65.6734Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    opacity: 0.05,
    d: "M93.6824 65.9298C93.6824 66.0843 93.6824 66.2276 93.6961 66.3447C93.741 66.9003 95.105 66.6897 95.105 66.6897C96.3508 66.8641 96.7992 66.2662 96.9475 65.6932C97.0209 65.3958 97.0365 65.0871 96.9935 64.7838V64.6704C96.7246 64.5908 96.4338 64.6501 96.2175 64.8286C95.6631 65.2783 94.9294 64.9333 94.9294 64.9333C94.9294 64.9333 94.39 64.9794 94.182 65.1587C94.0649 65.2596 93.8718 65.0167 93.726 64.785C93.7173 64.9345 93.7024 65.2048 93.6936 65.4938C93.6837 65.6396 93.6812 65.7891 93.6824 65.9298Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    opacity: 0.05,
    d: "M95.8701 65.895C95.8701 65.895 96.2438 66.2613 96.9477 65.6957C96.9947 65.5105 97.0181 65.32 97.0174 65.1289C96.6562 65.4017 95.9885 65.895 95.8701 65.895Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    opacity: 0.05,
    d: "M93.6825 65.9302C93.7437 65.9775 93.8218 65.9975 93.8983 65.9852C93.9747 65.9729 94.0427 65.9296 94.0861 65.8654C93.9406 65.755 93.807 65.6298 93.6874 65.4917C93.6837 65.6399 93.6812 65.7894 93.6825 65.9302Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("g", {
    id: "#gr",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M101.173 19.7788C101.199 19.7215 101.224 19.6642 101.248 19.6081C101.271 19.5521 101.28 19.5209 101.294 19.4761C101.248 19.5747 101.207 19.6757 101.173 19.7788Z",
    fill: "#FF5630"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6634 91.9419C33.3615 91.5785 33.2231 91.1065 33.281 90.6376L38.7796 45.646L39.2355 41.9089C39.3412 41.0489 40.0683 40.4007 40.9347 40.3941L57.0405 40.2869C57.5038 40.2841 57.9465 40.0948 58.2685 39.7617C58.5906 39.4286 58.7649 38.9799 58.7522 38.5168L58.7459 38.3461C58.7301 37.879 58.9045 37.4255 59.2293 37.0894C59.5541 36.7534 60.0014 36.5635 60.4688 36.5635H77.3931C78.3431 36.5635 79.1138 37.3325 79.1159 38.2826C79.1158 38.36 79.1108 38.4374 79.101 38.5143C79.0361 38.9992 79.1804 39.4888 79.4979 39.8609C79.8154 40.2331 80.2762 40.4528 80.7652 40.4651L97.0194 40.8799C97.5195 40.8922 97.9895 41.1214 98.3071 41.5079C98.6247 41.8944 98.7585 42.4 98.6737 42.893L90.5479 90.3548L90.3946 91.2517C90.3568 91.4809 90.2719 91.6997 90.1455 91.8945L33.6634 91.9419Z",
    fill: "#005249"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 82.7144,
    y: 27.0317,
    width: 9.51728,
    height: 32.3027,
    transform: "rotate(34.64 82.7144 27.0317)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 83.2788,
    y: 28.291,
    width: 6.71903,
    height: 6.71903,
    transform: "rotate(34.804 83.2788 28.291)",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    opacity: 0.5,
    x: 78.9565,
    y: 34.9395,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(34.64 78.9565 34.9395)",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    opacity: 0.3,
    x: 74.3384,
    y: 41.6226,
    width: 6.72813,
    height: 6.72813,
    transform: "rotate(34.64 74.3384 41.6226)",
    fill: "#FFAB00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 71.6514,
    y: 25.3672,
    width: 9.51729,
    height: 32.1806,
    transform: "rotate(16.29 71.6514 25.3672)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 72.8506,
    y: 26.2588,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(16.29 72.8506 26.2588)",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    opacity: 0.5,
    x: 70.5723,
    y: 34.0552,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(16.29 70.5723 34.0552)",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    opacity: 0.3,
    x: 68.2939,
    y: 41.8506,
    width: 6.72813,
    height: 6.72813,
    transform: "rotate(16.29 68.2939 41.8506)",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 65.1807,
    y: 25.854,
    width: 9.51729,
    height: 32.1806,
    transform: "rotate(4.6 65.1807 25.854)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 66.5308,
    y: 26.4849,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(4.6 66.5308 26.4849)",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    opacity: 0.5,
    x: 65.8784,
    y: 34.5801,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(4.6 65.8784 34.5801)",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    opacity: 0.3,
    x: 65.2275,
    y: 42.6772,
    width: 6.72812,
    height: 6.72812,
    transform: "rotate(4.6 65.2275 42.6772)",
    fill: "#00B8D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 60.9126,
    y: 27.144,
    width: 9.51728,
    height: 32.1806,
    transform: "rotate(-2.61 60.9126 27.144)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 62.3301,
    y: 27.5986,
    width: 6.72813,
    height: 6.72812,
    transform: "rotate(-2.61 62.3301 27.5986)",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    opacity: 0.5,
    x: 62.9634,
    y: 35.4551,
    width: 6.73653,
    height: 6.73653,
    transform: "rotate(-2.86241 62.9634 35.4551)",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    opacity: 0.3,
    x: 63.0693,
    y: 43.8271,
    width: 6.72812,
    height: 6.72813,
    transform: "rotate(-2.61 63.0693 43.8271)",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M64.9498 69.5525L56.4939 72.8238L44.1351 77.6011C43.668 76.7291 42.9803 75.5506 42.1295 74.1442C39.2021 69.2934 34.3587 61.7481 30.046 55.1171C25.1877 47.6428 21.0059 41.3357 21.0059 41.3357L24.033 40.4637L48.7605 33.2847L64.9498 69.5525Z",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    opacity: 0.1,
    d: "M64.9498 69.5525L56.4939 72.8237C51.7701 73.8079 46.9497 74.2509 42.1257 74.1442C39.1983 69.2934 34.355 61.7481 30.0423 55.1171L24.0342 40.4588L48.7604 33.2847L64.9498 69.5525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M71.2406 67.5172C71.2406 67.5172 58.1045 75.288 38.4919 73.5303L22.8569 35.4113L30.3499 34.1233L56.2534 29.6748L70.9529 66.776L71.2406 67.5172Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    opacity: 0.1,
    d: "M70.9476 66.7809C67.8544 66.9329 64.2755 66.9179 60.6754 66.4882C56.7788 66.0297 52.8597 65.0855 49.5 63.3539C46.6909 61.9077 44.2892 60.3343 42.1951 58.447C36.7476 53.5476 33.3767 46.5392 30.3496 34.1281L56.2531 29.6797L70.9476 66.7809Z",
    fill: "#FF5630"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M80.5843 64.6495C80.5843 64.6495 70.9014 66.5455 61.0452 65.3782C57.1486 64.9198 53.2296 63.9756 49.8699 62.244C47.0608 60.7977 44.6603 59.2244 42.565 57.3371C35.8232 51.2717 32.2629 41.9762 28.5918 23.2045C28.5918 23.2045 44.689 27.0898 60.6067 18.5791C60.6018 18.5853 65.9671 52.0677 80.5843 64.6495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9185 30.0957C36.9185 30.0957 50.0085 29.3557 53.6634 26.5342L54.2177 28.3156C54.2177 28.3156 45.5687 32.1312 36.9185 32.1773V30.0957Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9185 38.8904C36.9185 38.8904 49.5924 38.1966 59.1682 33.5712L59.4921 34.3112C59.4921 34.3112 51.8932 38.7472 36.9185 39.9082V38.8904Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.939 42.3175C37.939 42.3175 50.6129 41.6236 60.1875 36.9983L60.5114 37.7382C60.5114 37.7382 52.9125 42.173 37.939 43.3352V42.3175Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9578 45.7494C38.9578 45.7494 51.6318 45.0555 61.2076 40.4302L61.5302 41.1701C61.5302 41.1701 53.9314 45.6061 38.9578 46.7671V45.7494Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9779 49.1814C39.9779 49.1814 52.6519 48.4875 62.2265 43.8622L62.5504 44.6021C62.5504 44.6021 54.9515 49.0381 39.9779 50.1991V49.1814Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9968 52.6145C40.9968 52.6145 53.6708 51.9206 63.2466 47.2953L63.5692 48.0352C63.5692 48.0352 55.9704 52.47 40.9968 53.6323V52.6145Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.112 95.2268C130.112 95.2268 124.845 94.9092 125.466 98.6002C125.466 98.6002 125.341 99.2517 125.934 99.5482C125.934 99.5482 125.943 99.2742 126.473 99.3676C126.663 99.3994 126.855 99.4086 127.046 99.395C127.305 99.3777 127.55 99.2762 127.745 99.106C127.745 99.106 129.226 98.4943 129.802 96.0752C129.802 96.0752 130.228 95.547 130.21 95.4112L129.322 95.7849C129.322 95.7849 129.626 96.4264 129.387 96.9584C129.387 96.9584 129.358 95.8086 129.188 95.8372C129.153 95.8372 128.726 96.059 128.726 96.059C128.726 96.059 129.248 97.1801 128.85 97.9873C128.85 97.9873 129 96.6108 128.559 96.1399L127.936 96.5049C127.936 96.5049 128.546 97.6585 128.133 98.6002C128.133 98.6002 128.238 97.1564 127.804 96.5934L127.237 97.0356C127.237 97.0356 127.811 98.1729 127.461 98.954C127.461 98.954 127.415 97.2723 127.114 97.1452C127.114 97.1452 126.615 97.5825 126.543 97.7681C126.543 97.7681 126.935 98.5927 126.691 99.0287C126.691 99.0287 126.542 97.9076 126.42 97.9076C126.42 97.9076 125.921 98.655 125.874 99.1533C125.874 99.1533 125.895 98.3959 126.3 97.8316C126.015 97.8861 125.752 98.0224 125.543 98.224C125.543 98.224 125.62 97.6983 126.422 97.6535C126.422 97.6535 126.831 97.0904 126.939 97.0555C126.939 97.0555 126.142 96.9895 125.659 97.2038C125.659 97.2038 126.085 96.7055 127.086 96.9334L127.646 96.4775C127.646 96.4775 126.595 96.333 126.151 96.4925C126.151 96.4925 126.663 96.054 127.796 96.3679L128.405 96.0041C128.405 96.0041 127.511 95.8111 126.978 95.8796C126.978 95.8796 127.54 95.5756 128.585 95.9045L129.02 95.7089C129.02 95.7089 128.364 95.5843 128.172 95.5594C127.981 95.5345 127.969 95.4872 127.969 95.4872C128.385 95.4171 128.812 95.4646 129.201 95.6242C129.201 95.6242 130.127 95.2854 130.112 95.2268Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.565 83.0425C132.565 83.0425 129.596 82.8631 129.949 84.9447C129.912 85.1609 130.018 85.3766 130.212 85.4791C130.212 85.4791 130.218 85.3246 130.517 85.3769C130.624 85.3945 130.732 85.3995 130.84 85.3919C130.985 85.3825 131.123 85.3256 131.233 85.2299C131.233 85.2299 132.068 84.8849 132.393 83.5208C132.393 83.5208 132.634 83.2231 132.624 83.1471L132.125 83.3601C132.125 83.3601 132.296 83.7226 132.161 84.0228C132.161 84.0228 132.145 83.3738 132.049 83.3888C132.029 83.3888 131.789 83.5133 131.789 83.5133C131.789 83.5133 132.083 84.1362 131.861 84.6008C131.861 84.6008 131.946 83.8248 131.697 83.5582L131.344 83.765C131.344 83.765 131.688 84.4152 131.455 84.9459C131.455 84.9459 131.515 84.1312 131.269 83.8148L130.951 84.0639C130.951 84.0639 131.273 84.7055 131.075 85.1452C131.075 85.1452 131.049 84.1972 130.88 84.1262C130.759 84.2288 130.65 84.3455 130.557 84.4738C130.557 84.4738 130.779 84.9397 130.642 85.1851C130.642 85.1851 130.557 84.5535 130.488 84.551C130.488 84.551 130.209 84.9683 130.181 85.2548C130.194 84.989 130.277 84.7313 130.421 84.5074C130.26 84.5378 130.111 84.6149 129.994 84.7292C129.994 84.7292 130.037 84.4327 130.492 84.4078C130.492 84.4078 130.723 84.0901 130.784 84.0702C130.784 84.0702 130.334 84.0328 130.061 84.1536C130.061 84.1536 130.302 83.8746 130.866 84.0017L131.182 83.7438C131.182 83.7438 130.589 83.6628 130.339 83.7525C130.339 83.7525 130.628 83.5034 131.267 83.6852L131.611 83.4797C131.346 83.4218 131.075 83.3988 130.805 83.4112C130.805 83.4112 131.122 83.2393 131.71 83.4249L131.96 83.3153C131.96 83.3153 131.586 83.2418 131.481 83.2306C131.377 83.2193 131.367 83.1894 131.367 83.1894C131.601 83.1505 131.842 83.1772 132.062 83.2667C132.062 83.2667 132.575 83.0748 132.565 83.0425Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.04 84.8487C115.04 84.8487 111.455 84.6319 111.879 87.1445C111.833 87.4057 111.962 87.6663 112.196 87.7898C112.196 87.7898 112.196 87.603 112.57 87.6653C112.699 87.687 112.83 87.6933 112.96 87.6839C113.136 87.6722 113.303 87.6031 113.436 87.4871C113.436 87.4871 114.443 87.071 114.836 85.4242C114.836 85.4242 115.126 85.0654 115.114 84.972L114.502 85.2311C114.502 85.2311 114.709 85.6671 114.546 86.0296C114.546 86.0296 114.526 85.2473 114.41 85.2648C114.386 85.2648 114.096 85.4167 114.096 85.4167C114.096 85.4167 114.451 86.1766 114.183 86.7297C114.183 86.7297 114.285 85.7929 113.985 85.4715L113.559 85.7207C113.559 85.7207 113.974 86.5067 113.692 87.147C113.692 87.147 113.765 86.1642 113.469 85.7767L113.083 86.0782C113.083 86.0782 113.474 86.8518 113.235 87.3837C113.235 87.3837 113.205 86.2389 113 86.153C113 86.153 112.662 86.4507 112.611 86.5728C112.611 86.5728 112.878 87.1346 112.712 87.4311C112.712 87.4311 112.61 86.6687 112.526 86.6649C112.526 86.6649 112.191 87.1707 112.153 87.5158C112.169 87.1958 112.269 86.8858 112.443 86.6164C112.249 86.6534 112.07 86.7465 111.928 86.8842C111.928 86.8842 111.981 86.5267 112.526 86.4955C112.526 86.4955 112.804 86.1118 112.879 86.0894C112.879 86.0894 112.336 86.0433 112.007 86.1891C112.007 86.1891 112.296 85.8527 112.977 86.006L113.358 85.6945C113.358 85.6945 112.645 85.5974 112.341 85.7045C112.341 85.7045 112.689 85.4068 113.462 85.6248L113.877 85.3756C113.877 85.3756 113.268 85.2448 112.904 85.2922C112.904 85.2922 113.287 85.0854 113.997 85.3096L114.294 85.1763C114.294 85.1763 113.848 85.0891 113.717 85.0754C113.586 85.0617 113.58 85.0256 113.58 85.0256C113.863 84.9777 114.153 85.0096 114.419 85.1178C114.419 85.1178 115.051 84.8873 115.04 84.8487Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 83.8882,
    y: 27.5894,
    width: 21.2607,
    height: 38.0467,
    rx: 4.73723,
    transform: "rotate(-71.99 83.8882 27.5894)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4118 18.6278C98.4118 20.7853 96.6627 22.5343 94.5052 22.5343C92.3477 22.5343 90.5986 20.7853 90.5986 18.6278C90.5986 16.4702 92.3477 14.7212 94.5052 14.7212C96.6627 14.7212 98.4118 16.4702 98.4118 18.6278Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.852 17.9245L104.183 16.9068L120.369 22.1692L120.038 23.1869L103.852 17.9245Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.008 20.519L103.339 19.5014L111.585 22.182L111.254 23.1997L103.008 20.519Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.163 23.1152L102.494 22.0976L115.83 26.4332L115.499 27.4509L102.163 23.1152Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32 25.7104L101.651 24.6927L117.837 29.9551L117.506 30.9727L101.32 25.7104Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    opacity: 0.5,
    x: 111.5,
    y: 34.2139,
    width: 2.06914,
    height: 4.71006,
    transform: "rotate(-71.99 111.5 34.2139)",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    x: 80.5688,
    y: 64.5093,
    width: 20.9584,
    height: 32.6269,
    rx: 4,
    transform: "rotate(-57.2648 80.5688 64.5093)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.625 70.1544L104.609 59.1626L105.689 59.8487L98.7048 70.8405L97.625 70.1544Z",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9317 71.6188L106.915 60.627L107.995 61.3131L101.012 72.3049L99.9317 71.6188Z",
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6357 63.2792L87.8156 58.2743L88.9932 59.0225L85.8134 64.0274L84.6357 63.2792Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3996 64.2931L95.3833 53.3013L96.4631 53.9873L89.4794 64.9791L88.3996 64.2931Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7063 65.7573L97.69 54.7655L98.7698 55.4516L91.7861 66.4434L90.7063 65.7573Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0126 67.224L99.9963 56.2322L101.076 56.9183L94.0924 67.9101L93.0126 67.224Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3991 69.3489L102.431 58.4098L103.506 59.1007L96.4737 70.0398L95.3991 69.3489Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.616 65.3746L111.425 62.5284L114.271 64.3367L112.462 67.183L109.616 65.3746Z",
    fill: "#DFE3E8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M80.1986 45.817L61.1291 46.0225C60.4153 46.03 59.8404 46.6104 59.8398 47.3243V48.9001C59.8393 49.6068 59.2756 50.1843 58.5692 50.2019L44.809 50.532C44.2089 50.5471 43.6763 50.1498 43.5196 49.5703L42.8731 47.1947C42.7181 46.6216 42.1949 46.2261 41.6012 46.233L23.2207 46.4311C22.8395 46.4348 22.4792 46.6054 22.2347 46.8978C21.9902 47.1902 21.8862 47.5751 21.95 47.9509L29.3446 91.4713C29.4506 92.0959 29.9905 92.5537 30.624 92.5563L88.6919 92.8054C89.081 92.8068 89.4503 92.6341 89.6989 92.3347C89.9474 92.0353 90.0491 91.6405 89.9762 91.2583L81.4904 46.8746C81.3723 46.256 80.8283 45.8106 80.1986 45.817Z",
    fill: "url(#paint0_linear_3942_31356)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.211 99.8698C130.211 100.218 128.542 100.5 126.484 100.5C124.426 100.5 122.757 100.218 122.757 99.8698C122.757 99.5217 124.426 99.2395 126.484 99.2395C128.542 99.2395 130.211 99.5217 130.211 99.8698Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.623 85.6599C132.623 85.8559 131.682 86.0149 130.522 86.0149C129.361 86.0149 128.42 85.8559 128.42 85.6599C128.42 85.4638 129.361 85.3048 130.522 85.3048C131.682 85.3048 132.623 85.4638 132.623 85.6599Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.108 88.0094C115.108 88.246 113.972 88.4379 112.571 88.4379C111.17 88.4379 110.033 88.246 110.033 88.0094C110.033 87.7727 111.17 87.5808 112.571 87.5808C113.972 87.5808 115.108 87.7727 115.108 88.0094Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8497 83.2768C19.8497 83.4302 18.9456 83.5546 17.8303 83.5546C16.7151 83.5546 15.811 83.4302 15.811 83.2768C15.811 83.1234 16.7151 82.999 17.8303 82.999C18.9456 82.999 19.8497 83.1234 19.8497 83.2768Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1149 84.0604C12.1149 84.2138 11.2108 84.3382 10.0956 84.3382C8.98033 84.3382 8.07625 84.2138 8.07625 84.0604C8.07625 83.907 8.98033 83.7826 10.0956 83.7826C11.2108 83.7826 12.1149 83.907 12.1149 84.0604Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6264 86.294C14.6264 86.4027 13.9839 86.4908 13.1913 86.4908C12.3988 86.4908 11.7563 86.4027 11.7563 86.294C11.7563 86.1853 12.3988 86.0972 13.1913 86.0972C13.9839 86.0972 14.6264 86.1853 14.6264 86.294Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59865 86.0972C6.59865 86.2059 5.95615 86.294 5.16358 86.294C4.37102 86.294 3.72852 86.2059 3.72852 86.0972C3.72852 85.9885 4.37102 85.9003 5.16358 85.9003C5.95615 85.9003 6.59865 85.9885 6.59865 86.0972Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37278 85.6483C4.28252 85.5746 4.2169 85.4751 4.18467 85.363C4.1529 85.2471 4.20844 85.125 4.31672 85.0728C4.44129 85.0267 4.56586 85.1102 4.66552 85.1974C4.76518 85.2846 4.87854 85.3767 5.00311 85.3556C4.86862 85.2337 4.80807 85.0502 4.84366 84.8722C4.84876 84.836 4.86386 84.8019 4.88726 84.7738C4.95453 84.7016 5.07661 84.7327 5.15758 84.79C5.40672 84.9694 5.4852 85.317 5.48645 85.6309C5.49892 85.5158 5.49892 85.3997 5.48645 85.2846C5.47975 85.1667 5.53204 85.0533 5.62597 84.9819C5.68661 84.9488 5.75498 84.9324 5.82404 84.9345C5.9398 84.918 6.05714 84.9515 6.14668 85.0267C6.23393 85.1455 6.22878 85.3085 6.13422 85.4216C6.03878 85.5287 5.9259 85.6188 5.80037 85.6882C5.70509 85.7455 5.6238 85.8234 5.56244 85.9161C5.55491 85.9286 5.54905 85.942 5.545 85.956H4.81999C4.65769 85.8741 4.50725 85.7706 4.37278 85.6483Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0105 82.9302C16.92 82.8571 16.8543 82.7579 16.8224 82.6461C16.7904 82.5305 16.8454 82.4085 16.9532 82.3559C17.0777 82.3098 17.2023 82.3933 17.302 82.4805C17.4016 82.5677 17.5137 82.6623 17.642 82.6436C17.5075 82.5223 17.4465 82.3393 17.4813 82.1615C17.4869 82.1252 17.5024 82.0911 17.5262 82.0631C17.5934 81.9909 17.7155 82.022 17.7965 82.0781C18.0519 82.2587 18.1241 82.6063 18.1254 82.9202C18.1378 82.8047 18.1378 82.6882 18.1254 82.5726C18.1141 82.4562 18.1606 82.3417 18.2499 82.2662C18.3109 82.2339 18.3791 82.218 18.448 82.2201C18.5636 82.2038 18.6806 82.2368 18.7707 82.311C18.8582 82.4304 18.8525 82.5942 18.757 82.7072C18.6622 82.8145 18.5497 82.9047 18.4243 82.9738C18.329 83.0305 18.2477 83.108 18.1864 83.2005C18.1791 83.2135 18.1733 83.2273 18.169 83.2416H17.4602C17.2967 83.1589 17.1453 83.0541 17.0105 82.9302Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7989 85.6483C12.7087 85.5742 12.6428 85.4749 12.6096 85.363C12.5778 85.2471 12.6333 85.125 12.7416 85.0728C12.8662 85.0267 12.9907 85.1101 13.0904 85.1973C13.1901 85.2845 13.3009 85.3792 13.4305 85.3618C13.2962 85.2398 13.2353 85.0566 13.2698 84.8784C13.2753 84.8421 13.2908 84.808 13.3146 84.78C13.3819 84.7078 13.504 84.7389 13.585 84.7962C13.8403 84.9756 13.9113 85.3232 13.9138 85.6371C13.9263 85.522 13.9263 85.4059 13.9138 85.2908C13.904 85.1733 13.953 85.0585 14.0446 84.9843C14.1052 84.951 14.1736 84.9347 14.2427 84.937C14.3584 84.9206 14.4757 84.9541 14.5653 85.0292C14.6527 85.1481 14.647 85.3115 14.5516 85.4241C14.4566 85.5311 14.3442 85.6212 14.219 85.6906C14.1237 85.748 14.0425 85.8259 13.9811 85.9186C13.9736 85.9311 13.9677 85.9445 13.9637 85.9585H13.2411C13.0806 85.8752 12.9319 85.7709 12.7989 85.6483Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.88898 11.7513C5.88898 13.2394 4.68261 14.4458 3.19449 14.4458C1.70636 14.4458 0.5 13.2394 0.5 11.7513C0.5 10.2632 1.70636 9.05682 3.19449 9.05682C4.68261 9.05682 5.88898 10.2632 5.88898 11.7513Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.455 33.2835C135.455 34.7716 134.248 35.978 132.76 35.978C131.272 35.978 130.066 34.7716 130.066 33.2835C130.066 31.7954 131.272 30.589 132.76 30.589C134.248 30.589 135.455 31.7954 135.455 33.2835Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0189 3.19449C87.0189 4.68261 85.8126 5.88898 84.3244 5.88898C82.8363 5.88898 81.63 4.68261 81.63 3.19449C81.63 1.70636 82.8363 0.5 84.3244 0.5C85.8126 0.5 87.0189 1.70636 87.0189 3.19449Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0992 26.6165C13.0992 29.1104 11.0774 31.1322 8.58344 31.1322C6.08947 31.1322 4.06771 29.1104 4.06771 26.6165C4.06771 24.1225 6.08947 22.1007 8.58344 22.1007C11.0774 22.1007 13.0992 24.1225 13.0992 26.6165Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8454 62.9629C50.5224 62.9629 47.8286 65.6567 47.8286 68.9797C47.8286 72.3027 50.5224 74.9965 53.8454 74.9965C57.1684 74.9965 59.8622 72.3027 59.8622 68.9797C59.8622 65.6567 57.1684 62.9629 53.8454 62.9629V62.9629Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    opacity: 0.72,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8452 63.6626C56.7817 63.6626 59.1622 66.0431 59.1622 68.9795C59.1622 71.916 56.7817 74.2964 53.8452 74.2964C50.9088 74.2964 48.5283 71.916 48.5283 68.9795C48.5309 66.0441 50.9099 63.6652 53.8452 63.6626Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3573 69.4193L51.0663 69.1353C51.0035 69.0779 50.9678 68.9976 50.9678 68.9135C50.9678 68.8294 51.0035 68.7491 51.0663 68.6917L53.6191 66.1982C53.678 66.1369 53.7603 66.1021 53.8464 66.1021C53.9326 66.1021 54.0148 66.1369 54.0737 66.1982L56.6265 68.6895C56.6882 68.7476 56.723 68.8276 56.723 68.9113C56.723 68.9949 56.6882 69.075 56.6265 69.1331L56.3355 69.4171C56.276 69.4773 56.1939 69.5113 56.1082 69.5113C56.0225 69.5113 55.9404 69.4773 55.8809 69.4171L54.3715 67.8642V71.5489C54.3721 71.6305 54.3393 71.7089 54.2804 71.7668C54.2215 71.8247 54.1414 71.8573 54.0578 71.8573H53.6373C53.4628 71.8573 53.3213 71.7192 53.3213 71.5489V67.8687L51.8119 69.4215C51.7521 69.4814 51.6699 69.515 51.5841 69.5146C51.4984 69.5142 51.4165 69.4798 51.3573 69.4193Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0518 83.999C10.0518 83.999 12.8834 74.7159 9.60837 70.9975C7.15804 68.2158 4.37636 68.5484 3.13064 68.8922C2.47874 69.0663 1.93599 69.5176 1.64574 70.1267C1.20974 71.066 1.28822 72.5907 4.36265 74.3709C9.50871 77.3506 9.82886 81.4378 9.82886 81.4378L10.0518 83.999Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1669 84.0724C10.1669 84.0724 6.84954 77.3256 5.93892 77.4701C5.50665 77.5412 5.30734 77.9684 5.2164 78.3945C5.10459 78.9472 5.16772 79.5211 5.39703 80.0363C5.86791 81.1201 7.13232 83.1693 10.1669 84.0724Z",
    fill: "#303981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0681 84.0724C10.0681 84.0724 13.3842 77.3256 14.2948 77.4701C14.7283 77.5412 14.9277 77.9684 15.0174 78.3945C15.1292 78.9472 15.066 79.5211 14.8367 80.0363C14.3658 81.1201 13.1002 83.1693 10.0681 84.0724Z",
    fill: "#303981"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47646 70.178C3.49367 70.1231 3.55212 70.0926 3.60701 70.1098L3.57586 70.2092C3.60701 70.1098 3.60701 70.1098 3.60701 70.1098L3.60764 70.11L3.60903 70.1104L3.61407 70.112L3.63294 70.1183C3.64938 70.1238 3.67341 70.1321 3.70448 70.1433C3.76662 70.1657 3.85692 70.1999 3.97083 70.2472C4.19861 70.3419 4.52097 70.4894 4.90149 70.7015C5.66235 71.1256 6.65696 71.8085 7.59273 72.8441C9.46767 74.9191 11.0957 78.3989 10.1563 84.0165C10.1468 84.0732 10.0932 84.1115 10.0364 84.102C9.97967 84.0925 9.94136 84.0388 9.95085 83.9821C10.88 78.4255 9.26923 75.0103 7.43815 72.9838C6.52092 71.9687 5.54574 71.2991 4.80006 70.8835C4.42731 70.6757 4.11221 70.5316 3.89085 70.4396C3.78019 70.3936 3.693 70.3606 3.63379 70.3393C3.60418 70.3286 3.58158 70.3208 3.56655 70.3158L3.54974 70.3102L3.54572 70.3089L3.54484 70.3086C3.48996 70.2914 3.45926 70.2329 3.47646 70.178Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.538 71.0865C8.57013 71.1342 8.55755 71.1989 8.50992 71.2311L8.50957 71.2313L8.50771 71.2326L8.49939 71.2384C8.49189 71.2438 8.48059 71.2521 8.46615 71.2631C8.43723 71.2852 8.39579 71.3183 8.34693 71.3618C8.249 71.449 8.1225 71.5765 8.00734 71.7382C7.7772 72.0613 7.59739 72.5123 7.76743 73.0531C7.78469 73.108 7.75419 73.1664 7.69931 73.1837C7.64442 73.2009 7.58595 73.1704 7.56869 73.1156C7.37249 72.4916 7.58446 71.9728 7.83765 71.6173C7.96417 71.4397 8.10222 71.3007 8.20843 71.2062C8.26165 71.1588 8.30717 71.1224 8.33971 71.0975C8.35598 71.0851 8.36903 71.0756 8.37819 71.069L8.38895 71.0614L8.39199 71.0593L8.39291 71.0587L8.39332 71.0584C8.39332 71.0584 8.3934 71.0584 8.44959 71.1417L8.39332 71.0584C8.44103 71.0263 8.50585 71.0388 8.538 71.0865Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48716 71.9079L4.48815 71.9069L4.49309 71.9021C4.49768 71.8977 4.50482 71.891 4.51437 71.8824C4.5335 71.8652 4.56222 71.8405 4.59946 71.8119C4.67415 71.7546 4.78199 71.6821 4.91449 71.6214C5.17885 71.5004 5.53546 71.4284 5.9276 71.6093C5.97984 71.6334 6.04173 71.6106 6.06583 71.5584C6.08993 71.5061 6.06713 71.4442 6.01489 71.4201C5.55123 71.2062 5.12864 71.2942 4.82776 71.432C4.67763 71.5007 4.55634 71.5823 4.47255 71.6467C4.43056 71.679 4.3977 71.7071 4.37506 71.7275C4.36373 71.7377 4.35494 71.7459 4.34882 71.7518L4.34164 71.7588L4.33958 71.7608L4.33894 71.7615L4.33863 71.7618C4.33863 71.7618 4.33855 71.7619 4.41286 71.8349L4.33863 71.7618C4.2983 71.8028 4.29881 71.8689 4.33985 71.9092C4.38088 71.9495 4.44684 71.9489 4.48716 71.9079Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75974 75.523L7.76019 75.5228L7.76238 75.5217L7.77179 75.5172C7.78023 75.5131 7.79291 75.5071 7.80932 75.4997C7.84215 75.4849 7.88973 75.4645 7.94792 75.4422C8.06483 75.3975 8.22204 75.3465 8.38706 75.319C8.55337 75.2913 8.7189 75.2889 8.85719 75.3332C8.99064 75.376 9.10256 75.4629 9.16979 75.6276C9.19154 75.6809 9.25234 75.7064 9.30561 75.6847C9.35887 75.6629 9.38441 75.6021 9.36267 75.5489C9.27045 75.323 9.10846 75.1949 8.92075 75.1348C8.73788 75.0762 8.53499 75.0831 8.35281 75.1135C8.16934 75.1441 7.99799 75.2 7.87347 75.2476C7.81094 75.2715 7.75959 75.2936 7.72366 75.3098C7.70568 75.3179 7.69153 75.3246 7.68174 75.3293L7.67036 75.3348L7.66724 75.3364L7.66635 75.3368L7.66597 75.337C7.66597 75.337 7.6659 75.337 7.71281 75.43L7.66597 75.337C7.61461 75.3629 7.59391 75.4256 7.61982 75.4769C7.64573 75.5283 7.70839 75.5489 7.75974 75.523Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90483 78.6678C5.95219 78.6352 6.01706 78.6471 6.04972 78.6945L5.96396 78.7536L5.87821 78.8127C5.84555 78.7654 5.85747 78.7005 5.90483 78.6678ZM5.96396 78.7536C5.87821 78.8127 5.87821 78.8127 5.87821 78.8127L5.9176 78.8697C5.9433 78.9068 5.98107 78.9612 6.02937 79.0305C6.12596 79.1691 6.26468 79.3673 6.43323 79.6059C6.7703 80.0829 7.22686 80.7215 7.70458 81.3671C8.18208 82.0124 8.68163 82.6661 9.10447 83.1728C9.31576 83.426 9.50921 83.6441 9.672 83.8066C9.75335 83.8878 9.82841 83.9565 9.89526 84.0091C9.96016 84.0602 10.0248 84.1022 10.0846 84.1219C10.1392 84.1399 10.1981 84.1102 10.2161 84.0556C10.2341 84.0009 10.2044 83.9421 10.1498 83.924C10.1255 83.916 10.0841 83.8926 10.0241 83.8454C9.96607 83.7997 9.89738 83.7372 9.81918 83.6592C9.66287 83.5032 9.47404 83.2905 9.26443 83.0393C8.84549 82.5373 8.34877 81.8875 7.87205 81.2432C7.39555 80.5992 6.93993 79.9619 6.60338 79.4856C6.43512 79.2475 6.29667 79.0497 6.20029 78.9114C6.15211 78.8422 6.11444 78.7879 6.08883 78.751L6.04972 78.6945C6.04972 78.6945 6.04972 78.6945 5.96396 78.7536Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53956 79.5421C5.53956 79.4846 5.5862 79.4379 5.64373 79.4379H6.45594C6.51347 79.4379 6.56011 79.4846 6.56011 79.5421C6.56011 79.5996 6.51347 79.6463 6.45594 79.6463H5.64373C5.5862 79.6463 5.53956 79.5996 5.53956 79.5421Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51256 81.3838C6.51503 81.3263 6.56363 81.2817 6.62111 81.2842L7.89547 81.339C7.95295 81.3415 7.99754 81.3901 7.99507 81.4475C7.9926 81.505 7.944 81.5496 7.88652 81.5471L6.61215 81.4923C6.55468 81.4899 6.51009 81.4413 6.51256 81.3838Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41376 79.8088C7.47008 79.8206 7.50623 79.8757 7.4945 79.9321L7.35622 80.596C7.34449 80.6523 7.28933 80.6885 7.23301 80.6768C7.17668 80.665 7.14054 80.6099 7.15226 80.5535L7.29054 79.8896C7.30227 79.8333 7.35743 79.7971 7.41376 79.8088Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75093 81.8261C8.80841 81.8285 8.85308 81.877 8.85071 81.9345L8.82579 82.5374C8.82342 82.5949 8.7749 82.6395 8.71741 82.6372C8.65993 82.6348 8.61526 82.5863 8.61764 82.5288L8.64255 81.9259C8.64493 81.8684 8.69345 81.8237 8.75093 81.8261Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.186 78.6944C14.2187 78.647 14.2836 78.6352 14.3309 78.6679C14.3782 78.7006 14.3901 78.7655 14.3574 78.8128L14.2717 78.7536L14.186 78.6944ZM14.186 78.6944C14.186 78.6944 14.186 78.6944 14.2717 78.7536C14.3574 78.8128 14.3574 78.8128 14.3574 78.8128L14.3179 78.8697C14.2921 78.9068 14.2543 78.9612 14.2059 79.0306C14.1091 79.1692 13.9701 79.3674 13.8013 79.6059C13.4636 80.083 13.0063 80.7215 12.5281 81.3671C12.05 82.0125 11.5501 82.6661 11.1275 83.1728C10.9163 83.426 10.7231 83.6441 10.5607 83.8065C10.4796 83.8877 10.4048 83.9564 10.3383 84.009C10.2737 84.06 10.2095 84.1021 10.1501 84.1218C10.0955 84.14 10.0365 84.1105 10.0184 84.0559C10.0002 84.0013 10.0297 83.9423 10.0843 83.9241C10.1082 83.9162 10.1493 83.8928 10.2091 83.8456C10.2669 83.7998 10.3354 83.7373 10.4134 83.6593C10.5693 83.5032 10.758 83.2906 10.9675 83.0394C11.3863 82.5373 11.8834 81.8874 12.3607 81.2431C12.8377 80.5991 13.2941 79.9619 13.6312 79.4856C13.7998 79.2474 13.9385 79.0496 14.0351 78.9113C14.0834 78.8421 14.1211 78.7879 14.1468 78.7509L14.186 78.6944Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6751 79.5421C13.6751 79.4846 13.7218 79.4379 13.7793 79.4379H14.5915C14.649 79.4379 14.6957 79.4846 14.6957 79.5421C14.6957 79.5996 14.649 79.6463 14.5915 79.6463H13.7793C13.7218 79.6463 13.6751 79.5996 13.6751 79.5421Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7226 81.3838C13.7251 81.4413 13.6805 81.4899 13.623 81.4923L12.3486 81.5471C12.2912 81.5496 12.2426 81.505 12.2401 81.4475C12.2376 81.3901 12.2822 81.3415 12.3397 81.339L13.6141 81.2842C13.6715 81.2817 13.7201 81.3263 13.7226 81.3838Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8214 79.8088C12.8777 79.7971 12.9329 79.8333 12.9446 79.8896L13.0829 80.5535C13.0946 80.6099 13.0585 80.665 13.0021 80.6768C12.9458 80.6885 12.8906 80.6523 12.8789 80.596L12.7406 79.9321C12.7289 79.8757 12.7651 79.8206 12.8214 79.8088Z",
    fill: "#007B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4843 81.8261C11.5418 81.8237 11.5903 81.8684 11.5927 81.9259L11.6176 82.5288C11.62 82.5863 11.5753 82.6348 11.5179 82.6372C11.4604 82.6395 11.4119 82.5949 11.4095 82.5374L11.3846 81.9345C11.3822 81.877 11.4269 81.8285 11.4843 81.8261Z",
    fill: "#007B55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3942_31356",
    x1: 42.4286,
    y1: 32.6833,
    x2: 22.2464,
    y2: 92.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007B55"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordFound);
export default __webpack_public_path__ + "static/media/NoRecordFound.874dccdeb5d9327a4ea252b37875070a.svg";
export { ForwardRef as ReactComponent };